import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableHead, Tooltip, TableSortLabel } from '@mui/material/';
import { FormElements } from '@custom-components';
import * as styles from './SortableTable.styles';

class SortableTableHead extends Component {
  createSortHandler = (property) => (event) => {
    const { onRequestSort } = this.props;
    onRequestSort(event, property);
  };

  handleSelectAll = () => {
    const { onSelectAll } = this.props;
    onSelectAll();
  };

  render() {
    const { order, orderBy, columns, selectable, allSelected, hideHeaderCheckbox } = this.props;

    return (
      <TableHead>
        <TableRow>
          {selectable && (
            <styles.CheckboxCell key="checkbox" className="checkbox" heading="true">
              {!hideHeaderCheckbox && (
                <div className="checkbox">
                  <FormElements.Checkbox checked={allSelected} onChange={this.handleSelectAll} />
                </div>
              )}
            </styles.CheckboxCell>
          )}
          {columns.map(
            (column) => (
              <styles.Cell
                key={column.id}
                className={column.id}
                align={column.numeric ? 'right' : 'left'}
                padding={column.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === column.id ? order : false}
              >
                {!column.unsortable && (
                  <Tooltip
                    disableInteractive
                    title="Sort"
                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={order}
                      onClick={this.createSortHandler(column.id)}
                    >
                      {column.label}
                    </TableSortLabel>
                  </Tooltip>
                )}
                {column.unsortable && column.label}
              </styles.Cell>
            ),
            this
          )}
        </TableRow>
      </TableHead>
    );
  }
}

SortableTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      numeric: PropTypes.bool,
      disablePadding: PropTypes.bool,
      unsortable: PropTypes.bool,
      label: PropTypes.string
    })
  ),
  selectable: PropTypes.bool,
  allSelected: PropTypes.bool,
  hideHeaderCheckbox: PropTypes.bool,
  onSelectAll: PropTypes.func
};

SortableTableHead.defaultProps = {
  columns: [],
  selectable: false,
  allSelected: false,
  hideHeaderCheckbox: false,
  onSelectAll: () => {}
};
export default SortableTableHead;
